import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn convention: `cn()` is the className composer used everywhere.
// Combines clsx (handles conditionals/arrays/objects) with tailwind-merge
// (resolves conflicts like `p-2 p-4` → `p-4` rather than both).
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
